module.exports = __webpack_public_path__ + "static/communications-rooms-f47ca5738e84ebab3020bd2e104117c2.png";